












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsInstitutionsCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  situation: string;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions: any = {};

  mounted() {
    this.load();
    this.buildChartOptions();
  }

  buildChartOptions() {
    let kpisUse = new Array();
    kpisUse = kpisUse.concat(this.kpis).filter(i => i.situacao == this.situation);
    let paddingHeight = 10;
    let rowHeight = kpisUse.length * 25;
    let chartHeight = rowHeight + paddingHeight;

    if (chartHeight < 100) {
      chartHeight = 100;
    }

    this.chartOptions = {
      height: chartHeight,
      backgroundColor: 'transparent',
      chartArea: { left: '250', top: '0', right: '20', bottom: '50', height: rowHeight },
      legend: { position: 'bottom' },
      isStacked: true,
      colors: ['102D69', 'F5B830'],
      fontSize: 12
    };
  }

  load() {
    this.chartData = [];
    let kpisUse = new Array();
    kpisUse = kpisUse.concat(this.kpis).filter(i => i.situacao == this.situation);
    kpisUse.sort((o1, o2) =>
      o1.quantidadeTotal == o2.quantidadeTotal ? 0 : o1.quantidadeTotal < o2.quantidadeTotal ? 1 : -1
    );

    this.chartData.push([
      'Instituição',
      'Visitas',
      { role: 'annotation' }

    ]);
    kpisUse.forEach((i) => {
      this.chartData.push([
        `${StringUtils.abbreviate(i.nome, 25)} `,
        i.quantidadeTotal,
        i.quantidadeTotal
      ]);
    });

  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.buildChartOptions();
    this.load();
  }
}
